import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Colors } from 'modules/theme';

const MenuItemRoot = styled(MenuItem)({
  minHeight: 0,
  padding: '12px 24px',
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '24px',
  color: Colors.darkBlue,
  '&:focus-visible': {
    outline: '1px solid #949494',
    outlineOffset: '-1px',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  '&:hover': {
    outline: '1px solid #949494',
    outlineOffset: '-1px',
  },
  '&.Mui-focusVisible': {
    outline: '1px solid #949494',
    outlineOffset: '-1px',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  '&::after': {
    background: 'none',
  },
});

function AccountDropdownMenuItem({ text, onClick, className }) {
  return (
    <MenuItemRoot onClick={onClick} className={className} tabIndex={0}>
      {text}
    </MenuItemRoot>
  );
}

AccountDropdownMenuItem.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default memo(AccountDropdownMenuItem);
